<template>
  <div class="campaign-detail">
    <common-title
      class="campaign-detail-header"
      :title="campaign.name"
      :status="campaign.status"
      :start="adverDate.start"
      :end="adverDate.end"
    >
    </common-title>

    <div class="campaign-detail-panal">
      <pb-tab-panal :items="panals" :active="active" @action="handlerPanal" />
    </div>

    <!-- tab item -->
    <div>
      <campaign-manage v-if="active === 0" :idx="campaign.idx" />
      <campaign-statistic
        v-else
        :title="campaign.name"
        :start="adverDate.start"
        :end="adverDate.end"
        :status="status"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GET_STATUS, format } from "@/components/utils.js";
import CampaignStatistic from "@/views/campaign/containers/CampaignStatistic";
import CampaignManage from "@/views/campaign/containers/CampaignManage";
import CommonTitle from "@/common/CommonTitle";

export default {
  name: "CampaignDetail",
  data: () => ({
    active: 0,
    panals: [
      { label: "광고관리", value: "ad" },
      { label: "통계", value: "statistics" },
    ],
  }),
  computed: {
    ...mapState({
      items: "items",
      campaign: "campaign",
    }),

    status() {
      switch (this.campaign.status) {
        case "진행중":
          return "success";
        case "예약":
          return "disabled";
        case "종료":
          return "error";
        default:
          return "disabled";
      }
    },

    adverDate() {
      return {
        start: format("yyyy. MM. DD", this.campaign.start_date),
        end: format("yyyy. MM. DD", this.campaign.end_date),
      };
    },
  },
  methods: {
    handlerPanal(value, index) {
      this.active = index;
    },
  },
  components: {
    CampaignManage,
    CampaignStatistic,
    CommonTitle,
  },

  beforeUpdate() {
    this.campaign.status = GET_STATUS(
      this.campaign.start_date,
      this.campaign.end_date
    );
  },
};
</script>

<style lang="scss">
.campaign-detail {
  &-panal {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  &-header {
    &__date {
      font-size: 1.4rem;
    }
  }
}
</style>
